(() => {
  const MENU_ID = '108667';
  const CONTROLLER_KEY = '__summitPhotoMega108667';
  const MENU_SELECTOR = `.gm-desk .gm-menu-${MENU_ID}`;
  const DESKTOP_MEDIA = window.matchMedia('(min-width: 990px)');

  if (window[CONTROLLER_KEY]) {
    window[CONTROLLER_KEY].scheduleScan();
    return;
  }

  const menuPanels = readMenuPanelData();
  const boundItems = new WeakSet();

  let scanScheduled = false;
  let menuObserver;
  let observedMenuContainer;
  let panelIdSequence = 0;

  function readMenuPanelData() {
    const dataElement = document.getElementById('SummitPhotoMegaMenuData');
    if (!dataElement) return [];

    try {
      const data = JSON.parse(dataElement.textContent || '{}');
      if (!Array.isArray(data.panels)) return [];

      const validPanels = data.panels.filter(
        (panel) =>
          panel &&
          Number.isInteger(panel.index) &&
          typeof panel.key === 'string' &&
          panel.key.length > 0 &&
          typeof panel.title === 'string' &&
          panel.title.length > 0,
      );

      if (validPanels.length !== 3) {
        console.warn('[Summit Tools] Photo mega-menu requires all three menu panel definitions.');
        return [];
      }

      return validPanels.map((panel) => {
        const product = panel.product;
        const hasValidProduct =
          product &&
          typeof product.url === 'string' &&
          product.url.length > 0 &&
          typeof product.image === 'string' &&
          product.image.length > 0;

        return { ...panel, product: hasValidProduct ? product : null };
      });
    } catch (error) {
      console.warn('[Summit Tools] Photo mega-menu data could not be read.', error);
      return [];
    }
  }

  function createIntro(panel) {
    const intro = document.createElement('div');
    intro.className = 'summit-photo-mega__intro';

    const eyebrow = document.createElement('span');
    eyebrow.className = 'summit-photo-mega__eyebrow';
    eyebrow.textContent = `Shop ${panel.title}`;

    const description = document.createElement('p');
    description.className = 'summit-photo-mega__description';
    description.textContent = panel.description;

    intro.append(eyebrow, description);
    return intro;
  }

  function createProductCard(panel) {
    const card = document.createElement('a');
    card.className = 'summit-photo-mega__product';
    card.href = panel.product.url;
    card.setAttribute('aria-label', `View ${panel.product.title}`);

    const label = document.createElement('span');
    label.className = 'summit-photo-mega__product-label';
    label.textContent = 'Featured from our catalogue';

    const imageWrap = document.createElement('span');
    imageWrap.className = 'summit-photo-mega__image-wrap';

    const image = document.createElement('img');
    image.className = 'summit-photo-mega__image';
    image.src = panel.product.image;
    image.alt = panel.product.alt || panel.product.title;
    image.width = 1000;
    image.height = 1000;
    image.loading = 'lazy';
    image.decoding = 'async';

    const title = document.createElement('span');
    title.className = 'summit-photo-mega__product-title';
    title.textContent = panel.product.title;

    const cta = document.createElement('span');
    cta.className = 'summit-photo-mega__cta';
    cta.textContent = 'View product';

    imageWrap.append(image);
    card.append(label, imageWrap, title);

    if (panel.product.sku) {
      const sku = document.createElement('span');
      sku.className = 'summit-photo-mega__sku';
      sku.textContent = `SKU: ${panel.product.sku}`;
      card.append(sku);
    }

    card.append(cta);
    return card;
  }

  function setOpen(item, trigger, isOpen) {
    item.classList.toggle('summit-photo-mega--open', isOpen);
    trigger.setAttribute('aria-expanded', String(isOpen));
  }

  function addDesktopInteractions(item, trigger) {
    let closeTimer;

    const open = () => {
      if (!DESKTOP_MEDIA.matches) return;
      window.clearTimeout(closeTimer);
      delete item.dataset.summitEscapeClosed;

      Array.from(item.parentElement.children).forEach((sibling) => {
        if (sibling === item || !sibling.classList.contains('summit-photo-mega--open')) return;
        const siblingTrigger = sibling.querySelector(':scope > .gm-target');
        if (siblingTrigger) setOpen(sibling, siblingTrigger, false);
      });

      setOpen(item, trigger, true);
    };

    const close = () => {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        if (item.contains(document.activeElement)) return;
        setOpen(item, trigger, false);
      }, 120);
    };

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    item.addEventListener('focusin', (event) => {
      if (item.dataset.summitEscapeClosed === 'true' && event.target === trigger) return;
      open();
    });
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) {
        delete item.dataset.summitEscapeClosed;
        close();
      }
    });
    item.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      event.stopPropagation();
      window.clearTimeout(closeTimer);
      item.dataset.summitEscapeClosed = 'true';
      item.classList.remove('gm-active');
      setOpen(item, trigger, false);
      trigger.focus({ preventScroll: true });
    });
  }

  function normalizedTitle(item) {
    const text = item && item.querySelector(':scope > .gm-target .gm-text');
    return text ? text.textContent.trim().replace(/\s+/g, ' ').toLowerCase() : '';
  }

  function findTopItem(menu, panel) {
    const expectedTitle = panel.title.trim().replace(/\s+/g, ' ').toLowerCase();
    const byIndex = menu.querySelector(`:scope > .gm-item[data-gmmi="${panel.index}"]`);
    if (byIndex && normalizedTitle(byIndex) === expectedTitle) return byIndex;

    return Array.from(menu.querySelectorAll(':scope > .gm-item')).find(
      (item) => normalizedTitle(item) === expectedTitle,
    );
  }

  function enhanceMenu(menu) {
    if (!DESKTOP_MEDIA.matches || menuPanels.length !== 3) return;

    menu.classList.add('summit-photo-mega');
    let enhancedPanels = 0;

    menuPanels.forEach((panel) => {
      const item = findTopItem(menu, panel);
      const trigger = item && item.querySelector(':scope > .gm-target');
      const submenu = item && item.querySelector(':scope > .gm-submenu');
      let linkGrid = submenu && submenu.querySelector(':scope > .gm-grid');

// If Globo inserted the full navigation here, recover this panel's category grid.
if (linkGrid && linkGrid.matches(`.gm-menu-${MENU_ID}`)) {
  const nestedItem = findTopItem(linkGrid, panel);
  const categoryGrid = nestedItem &&
    nestedItem.querySelector(':scope > .gm-submenu > .gm-grid');

  if (categoryGrid && !categoryGrid.matches(`.gm-menu-${MENU_ID}`)) {
    linkGrid.replaceWith(categoryGrid);
    linkGrid = categoryGrid;
  }
}

      if (!item || !trigger || !submenu || !linkGrid) return;
      item.classList.add('summit-photo-mega__item', `summit-photo-mega__item--${panel.key}`);
      item.dataset.summitPhotoMegaItem = panel.key;
      submenu.classList.add('summit-photo-mega__panel');
      linkGrid.classList.add('summit-photo-mega__links');

      trigger.setAttribute('aria-haspopup', 'true');
      if (!trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'false');

      if (!submenu.id || document.getElementById(submenu.id) !== submenu) {
        panelIdSequence += 1;
        submenu.id = `SummitPhotoMega-${MENU_ID}-${panel.key}-${panelIdSequence}`;
      }
      trigger.setAttribute('aria-controls', submenu.id);

      if (!submenu.querySelector(`:scope > .summit-photo-mega__intro[data-panel="${panel.key}"]`)) {
        const intro = createIntro(panel);
        intro.dataset.panel = panel.key;
        submenu.insertBefore(intro, linkGrid);
      }

      const existingProductCard = submenu.querySelector(
        `:scope > .summit-photo-mega__product[data-panel="${panel.key}"]`,
      );
      submenu.classList.toggle('summit-photo-mega__panel--no-product', !panel.product);

      if (panel.product && !existingProductCard) {
        const productCard = createProductCard(panel);
        productCard.dataset.panel = panel.key;
        submenu.append(productCard);
      } else if (!panel.product && existingProductCard) {
        existingProductCard.remove();
      }

      if (!boundItems.has(item)) {
        addDesktopInteractions(item, trigger);
        boundItems.add(item);
      }

      enhancedPanels += 1;
    });

    if (menuPanels.length === 3 && enhancedPanels === 3) {
      document.documentElement.classList.add('summit-photo-mega-menu-ready');
    }
  }

  function scan() {
    scanScheduled = false;
    observeMenuContainer();

    if (!DESKTOP_MEDIA.matches) {
      document.querySelectorAll(`${MENU_SELECTOR} > .summit-photo-mega--open`).forEach((item) => {
        const trigger = item.querySelector(':scope > .gm-target');
        if (trigger) setOpen(item, trigger, false);
      });
      return;
    }

    document.querySelectorAll(MENU_SELECTOR).forEach(enhanceMenu);
  }

  function observeMenuContainer() {
    const container = document.querySelector('.gm-desk');
    if (!container || container === observedMenuContainer) return;

    if (menuObserver) menuObserver.disconnect();

    observedMenuContainer = container;
    menuObserver = new MutationObserver(scheduleScan);
    menuObserver.observe(container, { childList: true, subtree: true });
  }

  function scheduleScan() {
    if (scanScheduled) return;
    scanScheduled = true;
    window.requestAnimationFrame(scan);
  }

  function start() {
    scan();

    if (typeof DESKTOP_MEDIA.addEventListener === 'function') {
      DESKTOP_MEDIA.addEventListener('change', scheduleScan);
    } else {
      DESKTOP_MEDIA.addListener(scheduleScan);
    }

    window.addEventListener('pageshow', scheduleScan);
    document.addEventListener('shopify:section:load', scheduleScan);
  }

  window[CONTROLLER_KEY] = { scheduleScan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
